import React, { useState } from 'react';

const GOOGLE_APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbz2qPMNLJEBw4EwG3VVKAv55c2dZFSzFX9MP0QLjXjvXU1vAc02WBgmeDOdpJCbCxjl/exec';

const CustomForm = () => {
  const [formData, setFormData] = useState({
    nome: '', email: '', telefone: '', atividade: ''
  });
  const [errors, setErrors] = useState({});
  const [feedback, setFeedback] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: undefined }));
  };

  const validate = () => {
    const errs = {};
    if (!formData.nome.trim()) errs.nome = 'Nome é obrigatório';
    if (!formData.email.trim()) errs.email = 'Email é obrigatório';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) errs.email = 'Email inválido';
    if (!formData.telefone.trim()) errs.telefone = 'Telefone é obrigatório';
    if (!formData.atividade) errs.atividade = 'Selecione uma atividade';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    setFeedback(null);

    try {
      await fetch(GOOGLE_APPS_SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      setFeedback({ type: 'success', message: 'Dados enviados com sucesso!' });
      setFormData({ nome: '', email: '', telefone: '', atividade: '' });
    } catch {
      setFeedback({ type: 'error', message: 'Erro ao enviar. Tente novamente.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      backgroundColor: '#000000', minHeight: '100vh', display: 'flex',
      justifyContent: 'center', alignItems: 'center', fontFamily: 'Inter, sans-serif', padding: '20px'
    }}>
      <form onSubmit={handleSubmit} style={{
        backgroundColor: '#000000', padding: '40px', borderRadius: '12px',
        maxWidth: '500px', width: '100%', boxShadow: '0 0 20px rgba(255, 123, 0, 0.3)'
      }}>
        <h1 style={{ color: '#FFFFFF', fontSize: '28px', fontWeight: 'bold', textAlign: 'center', marginBottom: '30px' }}>
          Cadastro Pumpp
        </h1>

        {['nome', 'email', 'telefone'].map(campo => (
          <div key={campo} style={{ marginBottom: '20px' }}>
            <label style={{ color: '#FFFFFF', display: 'block', marginBottom: '8px', fontSize: '16px' }}>
              {campo === 'nome' ? 'Nome' : campo === 'email' ? 'Email' : 'Telefone'}
            </label>
            <input
              type={campo === 'email' ? 'email' : campo === 'telefone' ? 'tel' : 'text'}
              name={campo}
              value={formData[campo]}
              onChange={handleChange}
              placeholder={campo === 'nome' ? 'Seu nome' : campo === 'email' ? 'seu@email.com' : '(11) 99999-9999'}
              style={{
                width: '100%', height: '60px', padding: '16px', fontSize: '18px',
                backgroundColor: '#1a1a1a', border: '2px solid #FF7B00',
                borderRadius: '8px', color: '#FFFFFF', outline: 'none', boxSizing: 'border-box'
              }}
            />
            {errors[campo] && <div style={{ color: '#FF2A2A', fontSize: '14px', marginTop: '5px' }}>{errors[campo]}</div>}
          </div>
        ))}

        <div style={{ marginBottom: '20px' }}>
          <label style={{ color: '#FFFFFF', display: 'block', marginBottom: '8px', fontSize: '16px' }}>
            Atividade Principal
          </label>
          <select
            name="atividade" value={formData.atividade} onChange={handleChange}
            style={{
              width: '100%', height: '60px', padding: '16px', fontSize: '18px',
              backgroundColor: '#1a1a1a', border: '2px solid #FF7B00',
              borderRadius: '8px', color: '#FFFFFF', outline: 'none', boxSizing: 'border-box',
              appearance: 'none',
              backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23FF7B00%27 d=%27M6 8L1 3h10z%27/%3E%3C/svg%3E")',
              backgroundRepeat: 'no-repeat', backgroundPosition: 'right 16px center', backgroundSize: '12px',
              cursor: 'pointer'
            }}
          >
            <option value="">Selecione...</option>
            <option value="Musculação">Musculação</option>
            <option value="Crossfit">Crossfit</option>
            <option value="Corrida">Corrida</option>
            <option value="Funcional">Funcional</option>
            <option value="Outro">Outro</option>
          </select>
          {errors.atividade && <div style={{ color: '#FF2A2A', fontSize: '14px', marginTop: '5px' }}>{errors.atividade}</div>}
        </div>

        <button
          type="submit" disabled={loading}
          style={{
            width: '100%', height: '60px', backgroundColor: '#FF2A2A',
            border: 'none', borderRadius: '8px', color: '#FFFFFF', fontSize: '20px',
            fontWeight: 'bold', cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.7 : 1, transition: 'background-color 0.3s'
          }}
          onMouseEnter={(e) => !loading && (e.target.style.backgroundColor = '#FF7B00')}
          onMouseLeave={(e) => !loading && (e.target.style.backgroundColor = '#FF2A2A')}
        >
          {loading ? 'Enviando...' : 'Enviar'}
        </button>

        {feedback && (
          <div style={{
            marginTop: '20px', padding: '12px', borderRadius: '8px', textAlign: 'center',
            backgroundColor: '#1a1a1a',
            border: feedback.type === 'success' ? '2px solid #00FF00' : '2px solid #FF2A2A',
            color: feedback.type === 'success' ? '#00FF00' : '#FF2A2A'
          }}>
            {feedback.message}
          </div>
        )}
      </form>
    </div>
  );
};

export default CustomForm;